import { gsap } from './gsap';

const loader = async () => {
  const images = document.querySelectorAll('img');
  const loaderContainer = document.querySelector('.loader-container');
  const loaded = sessionStorage.getItem('loaded', true);
  const body = document.querySelector('body');
  const headerBorder = document.querySelectorAll('.header .border-reveal');
  const tl = gsap.timeline();

  let loadPercent;
  let pageStatus = null;
  let progress = 0;
  let animationInterval = 33;

  function checkAllImagesLoaded() {
    return new Promise((resolve) => {
      const imagePromises = Array.from(images).map((image) => new Promise((resolveImage) => {
        if (image.complete) {
          resolveImage();
        } else {
          image.addEventListener('load', resolveImage);
          image.addEventListener('error', resolveImage);
        }
      }));

      Promise.all(imagePromises).then(() => {
        pageStatus = 'complete';
        sessionStorage.setItem('loaded', true);
        resolve();
      });
    });
  }

  function sleep(ms) {
    return new Promise((resolve) => { setTimeout(resolve, ms); });
  }

  function createLoadPercent() {
    loadPercent = document.createElement('h1');
    loadPercent.className = 'title-serif title-serif__lg load-percent';
    loaderContainer.appendChild(loadPercent);
  }

  async function hideLoader() {
    tl.to(headerBorder, {
      '--border-width': '100%',
      scrollTrigger: {
        trigger: headerBorder,
        start: '70% bottom',
        toggleActions: 'play none none none',
      }
    }).to(loaderContainer, {
      autoAlpha: 0,
      onComplete: () => {
        loaderContainer.classList.add('loaded');
      }
    });
    body.classList.remove('overflow-hidden');
  }

  const calculateAnimationInterval = () => {
    if (progress <= 30) return 1;
    if (progress <= 60) return 2;
    if (progress <= 80) return 3;
    if (progress <= 90) return 4;
    return 0;
  };

  async function updateProgress() {
    if (pageStatus === 'complete' && progress >= 100) {
      return;
    }

    if (pageStatus === 'complete') {
      loadPercent.textContent = '100%';
      hideLoader();
    } else {
      body.classList.add('overflow-hidden');

      if (progress < 100) {
        progress += 1;
        animationInterval += calculateAnimationInterval(progress);
        loadPercent.textContent = `${progress}%`;
        await sleep(animationInterval);
        await updateProgress();
      }
    }
  }

  window.addEventListener('load', async () => {
    await checkAllImagesLoaded();
  });

  if (!loaded) {
    createLoadPercent();
    await updateProgress();
  } else {
    await hideLoader();
  }
};

export default loader;
